<template>
  <div class="push-info-container">
    <Loading v-if="loading"/>
    <LineOaButton v-if="!error" />
    <div v-if="error" class="error-message">
      <b-icon icon="exclamation-circle" variant="danger" font-scale="3"></b-icon>
      <p class="mt-3">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Page/Liff/Shared/Loading";
import LineOaButton from "@/components/Page/Liff/LineOaButton.vue";
import branchApi from "@/apis/liff/v2/branch";

export default {
  name: "LiffBranchPushInfo",
  components: {
    Loading,
    LineOaButton,
  },
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "",
    };
  },
  async mounted() {
    await this.pushBranchInfo();
  },
  methods: {
    async pushBranchInfo() {
      try {
        const branchHashid = this.$route.params.branch_hashid;

        // Call push API
        const response = await branchApi.pushBranchInfo(branchHashid);

        if (response.data.status === 'success') {
          // Redirect to OA page
          await this.redirectToOa();
        } else {
          this.error = true;
          this.errorMessage = response.data.message || '推播失敗';
        }
      } catch (error) {
        console.error('Push branch info error:', error);
        this.error = true;
        this.errorMessage = error.response?.data?.message || '推播時發生錯誤';
      } finally {
        this.loading = false;
      }
    },
    async redirectToOa() {
      try {
        const orgCode = this.$store.state.liffGeneral.orgCode;
        window.location.href = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/liff/general/redirect-to-oa`;
      } catch (error) {
        console.error('Redirect error:', error);
        this.error = true;
        this.errorMessage = '無法導向官方帳號';
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.push-info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-message {
  color: #dc3545;
}
</style>
